import { getDriverAnnualApproveList,getDriverApproveProgressList,submitDriverAudit } from "../../api/config/modules/DriverAnnualReview";

const state = {
    getDriverAnnualApproveList: {},
    getDriverApproveProgressList: {},
    submitDriverAudit: {}
};

const mutations = {
  SET_GETDRIVERANNUALAPPROVELIST: (state, getDriverAnnualApproveList) => {
    state.getDriverAnnualApproveList = getDriverAnnualApproveList;
  },
  SET_GETDRIVERAPPROVEPROGRESSLIST: (state, getDriverApproveProgressList) => {
    state.getDriverApproveProgressList = getDriverApproveProgressList;
  },
  SET_SUBMITDRIVERAUDIT: (state, submitDriverAudit) => {
    state.submitDriverAudit = submitDriverAudit;
  },
};

const actions = {
  GET_GETDRIVERANNUALAPPROVELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getDriverAnnualApproveList(data).then((res) => {
          commit("SET_GETDRIVERANNUALAPPROVELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETDRIVERAPPROVEPROGRESSLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getDriverApproveProgressList(data).then((res) => {
          commit("SET_GETDRIVERAPPROVEPROGRESSLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SUBMITDRIVERAUDIT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        submitDriverAudit(data).then((res) => {
          commit("SET_SUBMITDRIVERAUDIT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
